/* global axios */
import ApiClient from './ApiClient';

const getTimeOffset = () => -new Date().getTimezoneOffset() / 60;

class ReportsAPI extends ApiClient {
  constructor() {
    super('reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getReports({
    metric,
    from,
    to,
    type = 'account',
    id,
    groupBy,
    businessHours,
    onlyAssigned = false,
    conversationDirection,
  }) {
    return axios.get(`${this.url}`, {
      params: {
        metric,
        since: from,
        until: to,
        type,
        id,
        group_by: groupBy,
        business_hours: businessHours,
        timezone_offset: getTimeOffset(),
        only_assigned: onlyAssigned,
        conversation_direction: conversationDirection,
      },
    });
  }

  // eslint-disable-next-line default-param-last
  getSummary(
    since,
    until,
    // eslint-disable-next-line default-param-last
    type = 'account',
    id,
    groupBy,
    businessHours,
    conversationDirection
  ) {
    return axios.get(`${this.url}/summary`, {
      params: {
        since,
        until,
        type,
        id,
        group_by: groupBy,
        business_hours: businessHours,
        conversation_direction: conversationDirection,
        timezone_offset: getTimeOffset(),
      },
    });
  }

  getConversationMetric(type = 'account', page = 1, agentId = null) {
    let params = {
      type,
      page,
    };

    if (agentId) {
      params.id = agentId;
    }

    return axios.get(`${this.url}/conversations`, {
      params,
    });
  }

  getAgentReports({
    from: since,
    to: until,
    businessHours,
    conversationDirection,
  }) {
    return axios.get(`${this.url}/agents`, {
      params: {
        since,
        until,
        business_hours: businessHours,
        conversation_direction: conversationDirection,
      },
    });
  }

  getConversationTrafficCSV() {
    return axios.get(`${this.url}/conversation_traffic`, {
      params: { timezone_offset: getTimeOffset() },
    });
  }

  getLabelReports({
    from: since,
    to: until,
    businessHours,
    conversationDirection,
  }) {
    return axios.get(`${this.url}/labels`, {
      params: {
        since,
        until,
        business_hours: businessHours,
        conversation_direction: conversationDirection,
      },
    });
  }

  getInboxReports({
    from: since,
    to: until,
    businessHours,
    conversationDirection,
  }) {
    return axios.get(`${this.url}/inboxes`, {
      params: {
        since,
        until,
        business_hours: businessHours,
        conversation_direction: conversationDirection,
      },
    });
  }

  getAgentsInboxes({
    from: since,
    to: until,
    conversationDirection,
    agentIds,
    inboxIds,
  }) {
    return axios.get(this.url + '/agents_inboxes', {
      params: {
        since,
        until,
        conversation_direction: conversationDirection,
        agent_ids: agentIds,
        inbox_ids: inboxIds,
      },
    });
  }

  getAgentsInboxesCSV({
    from: since,
    to: until,
    conversationDirection,
    agentIds,
    inboxIds,
  }) {
    return axios.get(this.url + '/agents_inboxes.csv', {
      params: {
        since,
        until,
        conversation_direction: conversationDirection,
        agent_ids: agentIds,
        inbox_ids: inboxIds,
      },
    });
  }

  getTeamReports({
    from: since,
    to: until,
    businessHours,
    conversationDirection,
  }) {
    return axios.get(`${this.url}/teams`, {
      params: {
        since,
        until,
        business_hours: businessHours,
        conversation_direction: conversationDirection,
      },
    });
  }

  getBotMetrics({ from, to, conversationDirection } = {}) {
    return axios.get(`${this.url}/bot_metrics`, {
      params: {
        since: from,
        until: to,
        conversation_direction: conversationDirection,
      },
    });
  }

  getBotSummary({
    from,
    to,
    groupBy,
    businessHours,
    conversationDirection,
  } = {}) {
    return axios.get(`${this.url}/bot_summary`, {
      params: {
        since: from,
        until: to,
        type: 'account',
        group_by: groupBy,
        business_hours: businessHours,
        conversation_direction: conversationDirection,
      },
    });
  }

  getConversationsList({
    metric,
    from,
    to,
    type = 'account',
    id,
    page = 1,
    groupBy,
    businessHours,
    conversationDirection,
  }) {
    return axios.get(`${this.url}/conversations_list`, {
      params: {
        metric,
        since: from,
        until: to,
        type,
        id,
        page,
        group_by: groupBy,
        business_hours: businessHours,
        conversation_direction: conversationDirection,
        timezone_offset: getTimeOffset(),
      },
    });
  }
}

export default new ReportsAPI();
